import { render, staticRenderFns } from "./imageSideBox.vue?vue&type=template&id=8663c482&scoped=true"
import script from "./imageSideBox.vue?vue&type=script&lang=js"
export * from "./imageSideBox.vue?vue&type=script&lang=js"
import style0 from "./imageSideBox.vue?vue&type=style&index=0&id=8663c482&prod&lang=less"
import style1 from "./imageSideBox.vue?vue&type=style&index=1&id=8663c482&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8663c482",
  null
  
)

export default component.exports